export default __webpack_public_path__ + "static/media/Asset192.997bb675.svg";